import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js'
import './nlp/tabler.css';
import './panel.css';

import DatasetSelect from './DatasetSelect'
// import './jquery-simple-upload.css';
// import '@kanety/jquery-simple-upload';

function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring( o ){ return typeof(o) == 'string';}
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}

var companyList = [];
function getCompanies( callback )
{
	if( companyList.length ) callback( companyList )
	window.post( 'find_companies', {match:{active:true}}, function(res){
		if( res.status ) companyList = res.data.records;
		console.log( 'companyList', companyList );
		callback( companyList );
	})
}


function getDatasets( company, callback )
{
	window.post( 'find_file_datasets', {match:{"company":company,active:true}}, function(res){
		var dsList = [];
		if( res.status ) dsList = res.data.records;
		console.log( 'dsList', dsList );
		callback( dsList );
	})
}

function FileUpload(prop) {

    var global = window.GlobalVars;
    var tab;



	if( !window.GlobalVars.PDFProjectCompany ) window.GlobalVars.PDFProjectCompany = window.GlobalVars.userCompany;
	global.currentFileDataset  = [global.PDFProjectCompany,global.PDFProjectId,global.PDFProjectName].join('|');
	var [dataSetCompany,dataSetId,dataSetName] = global.currentFileDataset ? global.currentFileDataset.split('|') : [null,null,null];

	function newDataSet( user, add )
	{
		var content = `
		<p></p>
		<div id="datasetdetails">
		<label for="company">Company</label>
		<select placeholder="Company" type="text" id="company" class="mb-4 form-control"></select>
		<div id="datasetgroup">
		<label for="name">File Dataset</label>
		<select placeholder="Dataset" type="text" id="dataset" class="mb-4 form-control"></select>
		<input placeholder="Enter Dataset Name" type="text" id="datasetname" class="mb-4 form-control">
		</div>
		<button id="datasetbut" class="btn btn-primary">Select Dataset</button>
		</div>
		`;

		$('.maincontent').html(content);

		getCompanies( companyList => {
			companyList.forEach( c => {
				$('#company').append('<option>'+c.name+'</option>');
			});
			dataSetCompany = dataSetCompany || global.userCompany;
			$('#company').val(dataSetCompany);
			global.currentFileDataset = [dataSetCompany,null].join('|');
			$('#company').on('change', function(ev){
				var opttxt = $('#company option:selected').html()
				console.log( 'company', opttxt )
				dataSetCompany = $('#company').val();
				global.currentFileDataset = [dataSetCompany,null,null].join('|');
				window.saveSession();
				getDS();
			})
			getDS();
		});
		function getDS()
		{
			$('#datasetgroup').hide();
			$('#dataset').hide();
			$('#datasetname').val('').hide();
			getDatasets(dataSetCompany, dsList => {
				$('#datasetgroup').show();
				if( !dsList.length )
				{
					dataSetId = window.createId();
					$('#datasetname').val('').show().focus();
				}
				else {
					$('#dataset').show();

					$('#dataset').html('');
					dsList.forEach( c => {
						$('#dataset').append('<option value='+c.id+'>'+c.name+'</option>');
					});
					$('#dataset').append('<option value="">(Add new)</option>');
					$('#dataset').off('change').on('change', function(ev){
						var opttxt = $('#dataset option:selected').html()
						dataSetId = $('#dataset').val();
						$('#datasetname').val( opttxt )
						if( !dataSetId )
						{
							dataSetId = window.createId();
							$('#dataset').hide();
							$('#datasetname').val('').show().focus();
						}
					});
					$('#datasetname').val( dsList[0].id )
				}
			})
			$('#datasetbut').off('click').on('click', ev => {
				dataSetName = $('#datasetname').val().trim();
				global.currentFileDataset = [dataSetCompany,dataSetId,dataSetName].join('|');
			})
		}
	    return false;
	}

	function draw()
	{
		var [dataSetCompany,dataSetId,dataSetName] = global.currentFileDataset ? global.currentFileDataset.split('|') : [null,null,null];
		var extensions = ['pdf', 'txt'];
		var projectType = window.GlobalVars.PDFProjectType
		if( projectType == 'Classification' ) extensions = extensions.concat(['jpg','png', 'jpeg']);
		if( projectType == 'Media Transcription') extensions = ['mp4', 'mp3', 'wav'];
		if( projectType == 'AmEx Audio Templete') extensions = ['mp3', 'wav'];
		if( projectType == 'Code Switching') extensions = ['mp3', 'wav'];
		if( projectType == 'Pose Estimation' ) extensions = ['jpg','png', 'jpeg'];
		if( projectType == 'Segmentation' ) extensions = ['jpg','png', 'jpeg'];
		if( projectType == 'Key Point' ) extensions = ['jpg','png', 'jpeg'];

		if( projectType == 'OCR' ) extensions = ['pdf','jpg','png', 'jpeg','tiff','tif'];
		if( projectType == 'Comprehend NER' ) extensions = ['pdf', 'jpg','png', 'jpeg','tiff','tif'];
		var ext = '.'+extensions.join(',.');
		var allowed = new RegExp('.('+extensions.join('|')+')', 'i' )
		if( !dataSetId || !dataSetName ) return newDataSet();
		var content = `
		<input type="file" name="file" multiple="true" id="file_upload" class="display: hidden" accept="${ext}">
		<div id="basic_drop_zone" class="dropZone mt-3 mb-3">
		<div class="icon_text"><i class="fa fa-upload"></i>
		<p class="drop_files">Drop files here or click to upload</p> </div>
		<div id="basic_progress" class="alert alert-secondary"></div>
		<div id="basic_message" class="alert alert-primary"></div>
		<div id="basic_err" class="alert alert-danger"></div>
		</div>
		`;
		$('.maincontent').html(content);
		$('#basic_progress').hide();
		$('#basic_message').hide();
		$('#basic_err').hide();
		var errors = 0;
		// console.log( 'simple', $('.maincontent') )
		window.$('#file_upload').simpleUpload({
		  // url: 'http://localhost:8088/upload_file',
		  url: window.postURL('upload_file'),
		  method: 'post',
		  allowedFileName : allowed,
		  // dataType: '*.pdf,*.txt',
		  // params: { param: 'hello world' },
		  params: window.postParams( {dataset:global.currentFileDataset,project:global.PDFProjectId}),
		  dropZone: '#basic_drop_zone',
		  progress: '#basic_progress'
		}).on('upload:before', function(e, files) {
		  console.log('before');
		  console.log(files);
		}).on('upload:after', function(e, files) {
		  console.log('after');
		  console.log(files);
		  $('#basic_progress').hide();
		  window.post('upload_end', {dataset:global.currentFileDataset,project:global.PDFProjectId}, function(res){});
		  // if( !errors ) alert( 'go')
		}).on('upload:start', function(e, file, i) {
		  console.log('start ' + i);
		  console.log(file);
		}).on('upload:progress', function(e, file, i, loaded, total) {
		  console.log('progress ' + i + ' ' + loaded + '/' + total);
		  $('#basic_progress').show();
		}).on('upload:end', function(e, file, i) {
		  console.log('end ' + i);
		  console.log(file);
		}).on('upload:done', function(e, file, i) {
		  console.log('done ' + i);
		  console.log(file);
		  $('#basic_message').show();
		  $('#basic_message').prepend('<div>done: ' + file.name + '</div>');
		}).on('upload:fail', function(e, file, i) {
		  console.log('fail ' + i);
		  console.log(file);
		  $('#basic_err').prepend('<div>fail: ' + file.name + '</div>');
		  $('#basic_err').show();
		  errors++;
		});
		$('#basic_drop_zone').on('click', ev=>{
			$('#file_upload')[0].click();
		})
		$('.maincontent').append('<div class="wizzbtn">');
		if( !window.GlobalVars.PDFProjectActive ) {
			window.wizzardBar(true)
			window.wizzardButtons( $('.wizzbtn') )
			window.topBarVisible()
		}
	}


    useEffect( function(a){
		draw();
    });


	if( 1 || global.PDFProjectType == 'Bulk Image Classification') {
		draw = function(){}
		return (
			<DatasetSelect/>
		)
	}

    return (
		<>
        <div fluid="md p-0" className="maincontent">
        <span>&nbsp;</span>
        </div>
		</>
    )
}

export default FileUpload
